import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { getIsAlamaly } from 'utils/helpers/getIsAlamaly';

export type SupportedLanguage = 'en' | 'ru' | 'es' | 'fr';

const SUPPORTED_LANGUAGES: SupportedLanguage[] = ['en', 'ru', 'es', 'fr'];
const LANGUAGE_KEY = 'sight3_language';

export const detectInitialLanguage = (): SupportedLanguage => {
  if (getIsAlamaly()) return 'ru';
  try {
    const stored = localStorage.getItem(LANGUAGE_KEY);
    if (stored && SUPPORTED_LANGUAGES.includes(stored as SupportedLanguage)) {
      return stored as SupportedLanguage;
    }
    const browserLang = navigator.language.split('-')[0];
    if (SUPPORTED_LANGUAGES.includes(browserLang as SupportedLanguage)) {
      return browserLang as SupportedLanguage;
    }
  } catch {
    // localStorage unavailable
  }
  return 'en';
};

interface LanguageState {
  language: SupportedLanguage;
}

const initialState: LanguageState = {
  language: detectInitialLanguage(),
};

export const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage(state, { payload }: PayloadAction<SupportedLanguage>) {
      state.language = payload;
      try {
        localStorage.setItem(LANGUAGE_KEY, payload);
      } catch {
        // localStorage unavailable
      }
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
